import * as React from 'react';
import {ReactComponent as InfoIcon} from '@iba-team/portal-react-components/dist/svg/outline/information.svg';
import './TypeLegend.scss';
import { Popover } from '@iba-team/portal-react-components/dist';
import { requireIcon } from '../components/LeaveTypes';
import { TooltipPlacement } from 'antd/es/tooltip';

interface Props<T>{
  renderItem:  (data: T) => string,
  list: T[],
  placement? : TooltipPlacement
}


function TypeMap<T>(props: Props<T>){
  return(
    <div className={'typeList'}>
      {props.list.map(i => (
        <span className={'typeItem'}>
          <img src={ requireIcon(props.renderItem(i)) } alt={'leaveType'}/>
          <span className='types-living'>{props.renderItem(i)}</span>
        </span>))}
    </div>
  );
}
export function TypeLegend<T>(props: Props<T>){
  return (
    <Popover placement={props.placement} className={'tooltipLegend'} content={<TypeMap {...props}/>}>
      <div className={'typeLegend'}>
        <InfoIcon className={'svg'}/>
        <span>Leave types</span>
      </div>
    </Popover>
  );
}
